/* eslint-disable */
import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import "../../styles/challanlist.css";
import {
  getActiveExamList,
  getExamTypeForTimeTable,
  getLanguageDetailsForTimeTable,
  updateExamTimeTable,
  setAdmitCardTemplateDropdown,
  deleteTimeTableDetailById,
} from "../../timetablemanagement/actions/timetableManagementAction";
import TimeTableLabels from "../labels/timetable_en.json";
import commonLabels from "../../common/labels/common_en.json";
import venueLabels from "../../venuemanagement/labels/venue_en.json";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import _ from "lodash/fp";
import { getAllExamSubjectsData } from "../../admin/masterManagement/actions/masterManagementAction";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import CDNCKEditor from "../../common/components/CDNCKEditor";
import "../../styles/time_table_management.css";
import Devnagari from "../../admin/masterManagement/components/devnagari";
import { GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID } from "../../common/constants/ActionTypes";

const UpdateTimeTableDetails = (props) => {
  const { register, control, errors } = useForm({
    mode: "onChange",
  });

  const {
    getActiveExamListData,
    getExamType,
    getLanguageData,
    getAdmitCardTemplateList
  } = useSelector((state) => state.timeTableManagementReducer, shallowEqual);

  const { parentExamsubjectData } = useSelector(
    (state) => state.masterManagementReducer,
    shallowEqual
  );
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const dispatch = useDispatch();
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedExamDate, setSelectedExamDate] = useState("");
  const [presentTime, setPresentTime] = useState("");
  const [lastEnterTime, setLastEnterTime] = useState("");
  const [examStartTime, setExamStartTime] = useState("");
  const [examEndTime, setExamEndTime] = useState("");
  const [examSubject, setExamSubject] = useState("");
  const [subjectCode, setSubjectCode] = useState("");
  const [examType, setExamType] = useState("");
  const [language, setLanguage] = useState("");
  const [impInstruction, setImpInstruction] = useState("");
  const [candidateInstruction, setCandidateInstruction] = useState("");
  const [authority, setAuthority] = useState("");
  const [signature, setSignature] = useState("");
  const [signatureLengthErr, setSignatureLengthErr] = useState(false);
  const [authorityLengthErr, setAuthorityLengthErr] = useState(false);
  const [examTemplate, setExamTemplate] = useState("");
  const [examTemplateErr, setExamTemplateErr] = useState(true);
  const [admitCardDisplayName, setAdmitCardDisplayName] = useState("");
  const [admitCardDisplayNameErr, setAdmitCardDisplayNameErr] = useState(true);
  const [tempTimeTableData, setTempTimeTableData] = useState([]);
  const [checkedValues, setCheckedValues] = useState([]);
  const [checkedValue, setCheckedValue] = useState(false);
  const [selectExamid,setSelectExamId]=useState("");

  let TimeTableDetailsHeaders = [
    <input
      type="checkbox"
      onChange={(e) => onhandleSelectAll(e.target.checked)}
      checked={
        props?.timeTableData?.timeTableExamsDtoList?.length ==
        checkedValues?.length
          ? true
          : false
      }
    />,
    "Sr. No.",
    "Exam Name",
    "Date of Examination",
    "Present Time",
    "Last Time of Enter Examination Hall",
    "Exam Start Time",
    "Exam End Time",
    "Exam Subject",
    "Language",
    "Subject Code",
    "Exam Type",
  ];
  useEffect(() => {
    props && props.advId && dispatch(getActiveExamList(props.advId));
    dispatch(getExamTypeForTimeTable());
    dispatch(getAllExamSubjectsData());
    dispatch(getLanguageDetailsForTimeTable());
    dispatch(setAdmitCardTemplateDropdown());
    
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
      let timeTableDetailsData = props && props.timeTableDetails && props.timeTableDetails.examInstructionsDtoList && props.timeTableDetails.examInstructionsDtoList.find(e => e.templateId === props.templateId)
      setImpInstruction(
        timeTableDetailsData && timeTableDetailsData.importantInstructions
      );
      setCandidateInstruction(
        timeTableDetailsData && timeTableDetailsData.studentInstructions
      );
      setAuthority(timeTableDetailsData && timeTableDetailsData.examAuthority);
      setSignature(
        timeTableDetailsData && timeTableDetailsData.examAuthoritySignature
      );
      setExamTemplate(timeTableDetailsData && timeTableDetailsData.templateId);
      setAdmitCardDisplayName(
        timeTableDetailsData && timeTableDetailsData.examDisplayName
      );
      let timeTableExamsDtoList =
        props && props.timeTableData && props.timeTableData.timeTableExamsDtoList;
      const newData =
        timeTableExamsDtoList &&
        timeTableExamsDtoList.map((exam) => {
          const preTime = exam.presentTime.split(":");
          const updatedPresentTime = dayjs(exam.examDate).toDate();
          updatedPresentTime.setHours(preTime[0]);
          updatedPresentTime.setMinutes(preTime[1]);
          updatedPresentTime.setSeconds(preTime[2]);
  
          let finalGetInTime = exam.getInTime.split(":");
          let updatedGetInTime = dayjs(exam.examDate).toDate();
          updatedGetInTime.setHours(finalGetInTime[0]);
          updatedGetInTime.setMinutes(finalGetInTime[1]);
          updatedGetInTime.setSeconds(finalGetInTime[2]);
  
          let finalDurationFromTime = exam.durationFrom.split(":");
          let updatedDurationFromTime = dayjs(exam.examDate).toDate();
          updatedDurationFromTime.setHours(finalDurationFromTime[0]);
          updatedDurationFromTime.setMinutes(finalDurationFromTime[1]);
          updatedDurationFromTime.setSeconds(finalDurationFromTime[2]);
  
          let finalDurationToTime = exam.durationTo.split(":");
          let updatedDurationToTime = dayjs(exam.examDate).toDate();
          updatedDurationToTime.setHours(finalDurationToTime[0]);
          updatedDurationToTime.setMinutes(finalDurationToTime[1]);
          updatedDurationToTime.setSeconds(finalDurationToTime[2]);
  
          let examSubjectId = "";
          parentExamsubjectData &&
            parentExamsubjectData.examSubjectList &&
            parentExamsubjectData.examSubjectList.map((e) => {
              let subCode = exam && exam.subjectCodes;
              if (e.code == subCode) {
                examSubjectId = e.id;
              }
            });
          return {
            mode: "Add",
            isDeleted: false,
            id: exam.id,
            selectedExam: exam.examId.toString(),
            examDate: new Date(exam.examDate).toISOString(),
            presentTime: updatedPresentTime,
            lastEnterTime: updatedGetInTime,
            examStartTime: updatedDurationFromTime,
            examEndTime: updatedDurationToTime,
            examSubject: examSubjectId,
            subjectCode: exam.subjectCodes,
            examType: exam.examPattern.toString(),
            language:
              exam &&
              exam.tableExamSubjectsDto &&
              exam.tableExamSubjectsDto.id &&
              exam.tableExamSubjectsDto.id,
          };
        });
      setTempTimeTableData(newData);
    }, [props, parentExamsubjectData]);

  const handleSubjectChange = (value) => {
    setLanguage("");
    setExamSubject(value);
    parentExamsubjectData &&
      parentExamsubjectData.examSubjectList &&
      parentExamsubjectData.examSubjectList.map((e) => {
        if (e.id == value) {
          setSubjectCode(e.code);
        }
      });
  };

  useEffect(() => {
    if (getActiveExamListData && getActiveExamListData.length > 0) {
      const nonDeletedExams = getActiveExamListData.filter((element) => !element.isDeleted);
      if (nonDeletedExams.length > 0) {
        setSelectedExam(nonDeletedExams[0].name);
        setSelectExamId(nonDeletedExams[0].id)
      }
    }
  }, [getActiveExamListData]);
  
  const cancelModal = () => {
    props.setShowUpdateModal(false);
    setSelectedExam("");
    setSelectedExamDate("");
    setPresentTime("");
    setLastEnterTime("");
    setExamStartTime("");
    setExamEndTime("");
    setExamSubject("");
    setSubjectCode("");
    setExamType("");
    setLanguage("");
    setCandidateInstruction("");
    setImpInstruction("");
    setExamTemplate("");
    setExamTemplateErr(false);
    setAdmitCardDisplayName("");
    setAdmitCardDisplayNameErr(false);
    setTempTimeTableData([]);
    dispatch({
        type:GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID,
        payload:[]
    })
  };

  const handleSubmit = () => {
    let requestBody = {};
    requestBody.timeTableExamsDtoList = {};
    let timeTableDetailsData = props && props.timeTableDetails && props.timeTableDetails.examInstructionsDtoList && props.timeTableDetails.examInstructionsDtoList.find(e => e.templateId === props.templateId)

    let timeTableExamsDtoId =
      props &&
      props.timeTableData &&
      props.timeTableData.timeTableExamsDto &&
      props.timeTableData.timeTableExamsDto.id;

    let objData = {};
    objData.id = timeTableExamsDtoId;
    if (Array.isArray(checkedValues)) {
      checkedValues.forEach((e) => {
        if (e.selectedExam) {
          e.examId = e.selectedExam;
        }
        if (e.presentTime) {
          let presentTimeVal = new Date(e.presentTime);
          e.presentTime = presentTimeVal.toLocaleTimeString(TimeTableLabels.itIT);
        }
        if (e.lastEnterTime) {
          let getInTimeVal = new Date(e.lastEnterTime);
          e.getInTime = getInTimeVal.toLocaleTimeString(TimeTableLabels.itIT);
        }
        if (e.examStartTime) {
          let examStartTimeVal = new Date(e.examStartTime);
          e.durationFrom = examStartTimeVal.toLocaleTimeString(TimeTableLabels.itIT);
        }
        if (e.examEndTime) {
          let examEndTimeVal = new Date(e.examEndTime);
          e.durationTo = examEndTimeVal.toLocaleTimeString(TimeTableLabels.itIT);
        }
        if (e.subjectCode) {
          e.subjectCodes = e.subjectCode;
        }
        if (e.language) {
          e.timeTableExamSubjectsId = e.language;
        }
        if (e.examType) {
          e.examPattern = e.examType;
        }
      });
    }
    requestBody.timeTableExamsDtoList.id = timeTableExamsDtoId;
    if(checkedValues){
        requestBody.timeTableExamsDtoList = checkedValues
    }
    requestBody.studentInstructions = candidateInstruction;
    requestBody.importantInstructions = impInstruction;
    requestBody.examAuthority = authority;
    requestBody.examAuthoritySignature = signature;
    requestBody.templateId = examTemplate;
    requestBody.examDisplayName = admitCardDisplayName;
    requestBody.examInstructionsId = timeTableDetailsData.id;
    dispatch(updateExamTimeTable(requestBody, props.advId));
    props.setShowUpdateModal(false);
    setSelectedExam("");
    setSelectedExamDate("");
    setPresentTime("");
    setLastEnterTime("");
    setExamStartTime("");
    setExamEndTime("");
    setExamSubject("");
    setSubjectCode("");
    setExamType("");
    setLanguage("");
    setCandidateInstruction("");
    setImpInstruction("");
    setExamTemplate("");
    setExamTemplateErr(false);
    setAdmitCardDisplayName("");
    setAdmitCardDisplayNameErr(false);
    setTempTimeTableData([]);
    dispatch({
        type: GET_TIME_TABLE_DETAILS_BY_TEMPLATE_ID,
        payload: []
    });
  };


  const handleExamTemplateChange = (value) => {
    if (value) {
      setExamTemplate(value);
      setExamTemplateErr(false);
    } else {
      setExamTemplate(value);
      setExamTemplateErr(true);
    }
  };

  const handleAdmitCardDisplayNameChange = (value) => {
    if (value) {
      setAdmitCardDisplayName(value);
      setAdmitCardDisplayNameErr(false);
    } else {
      setAdmitCardDisplayName(value);
      setAdmitCardDisplayNameErr(true);
    }
  };

  const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  const getExamName = (id) => {
    let ExamName =
      getActiveExamListData &&
      getActiveExamListData.length > 0 &&
      getActiveExamListData.map((e) => {
        if (e.id == id) {
          return e.name;
        }
      });
    return ExamName;
  };

  const examSubjectName = (id) => {
    let ExamName =
      parentExamsubjectData &&
      parentExamsubjectData.examSubjectList &&
      parentExamsubjectData.examSubjectList.length > 0 &&
      parentExamsubjectData.examSubjectList.map((e) => {
        if (e.id == id) {
          return e.name;
        }
      });
    return ExamName;
  };

  const examTypeName = (id) => {
    let ExamTypeName =
      getExamType &&
      getExamType.length > 0 &&
      getExamType.map((e) => {
        if (e.id == id) {
          return e.label;
        }
      });
    return ExamTypeName;
  };

  const languageName = (id) => {
    let setLanguageName =
      getLanguageData &&
      getLanguageData.timeTableExamSubjectsDtoList &&
      getLanguageData.timeTableExamSubjectsDtoList.length > 0 &&
      getLanguageData.timeTableExamSubjectsDtoList.map((e) => {
        if (e.id == id) {
          return e.subjectName;
        }
      });
    return setLanguageName;
  };

  const handleEditClick = (obj, index) => {
    setSelectedExam(obj.selectedExam);
    setSelectedExamDate(obj.examDate);
    setPresentTime(obj.presentTime);
    setLastEnterTime(obj.lastEnterTime);
    setExamStartTime(obj.examStartTime);
    setExamEndTime(obj.examEndTime);
    setExamSubject(obj.examSubject);
    setSubjectCode(obj.subjectCode);
    setLanguage(obj.language);

    if (obj.examType) {
      setExamType(obj.examType);
    }
    tempTimeTableData &&
      tempTimeTableData.forEach((e, rowInd) => {
        if (index === rowInd) {
          e.mode = "Edit";
        } else {
          e.mode = "Add";
        }
        return e;
      });
  };

  const findDuplicateObjects = (obj, arr) => {
    for (let i = 0; i < arr.length; i++) {
      const currentObject = arr[i];

      if (areObjectsEqual(obj, currentObject)) {
        return true;
      }
    }

    return false;
  };

  const areObjectsEqual = (obj1, obj2) => {
    const keys = Object.keys(obj1);

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (key.includes("Time") || key === "examDate") {
        const date1 = new Date(obj1[key]).toISOString().slice(0, 19);
        const date2 = new Date(obj2[key]).toISOString().slice(0, 19);

        if (date1 !== date2) {
          return false;
        }
      } else if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  };

  const onCheckedValue = (e, item) => {
    const isChecked = e;

    setCheckedValue(isChecked);
    setCheckedValues((checkedValues) => {
      if (isChecked) {
        return [...checkedValues, item];
        
      } else {
        const updatedCheckedValues = checkedValues.filter(
          (value) => value.id !== item.id
        );
        if (
          checkedValue &&
          updatedCheckedValues.length === checkedValues.length
        ) {
          setCheckedValue(false);
        }
        return updatedCheckedValues;
      }
    });
  };

  const onhandleSelectAll = (e) => {
    if (e) {
      setCheckedValues(tempTimeTableData);
    } else {
      setCheckedValues([]);
    }
  };


  return (
    <div>
      <Modal
        size="xl"
        show={props.showUpdateModal}
        onHide={cancelModal}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header  className="d-flex justify-content-between align-items-center logout_heading">
          <Modal.Title className="logout_title"> {TimeTableLabels.UPDATE_TIME_TABLE}</Modal.Title>
            <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="row">
              <div className="col-md-4">
                <label className="LeftText">
                  {TimeTableLabels.SELECT_EXAM}
                  <span className="errorText">*</span>
                </label>
                <div className="input-group bg-color">
                  <select
                    className="form-select  bg-color"
                    name="examName"
                    value={selectedExam}
                    defaultValue={selectedExam}
                  //   onInput={handleExamChange}
                    ref={register({ required: true })}
                  >
                    <option key={0} value="">
                      {selectedExam}
                    </option>
                    {/* {getActiveExamListData &&
                      getActiveExamListData.length > 0 &&
                      getActiveExamListData
                        .filter((element) => element.isDeleted == false)
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))} */}
                  </select>
                </div>
                {_.get("examName.type", errors) === "required" && (
                  <p className="errorText">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="timeTableDetailsSection">
            <h5 className="float-left w-100 text-left">
              {TimeTableLabels.TIME_TABLE_DETAILS}{" "}
            </h5>
            {tempTimeTableData && tempTimeTableData.length > 0 ? (
              <div className="mt-3">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {TimeTableDetailsHeaders &&
                        TimeTableDetailsHeaders.map((itm, ind) => (
                          <th key={ind} className='theadBgColor'>{itm}</th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tempTimeTableData &&
                      tempTimeTableData.length > 0 &&
                      tempTimeTableData
                        .filter((item) => item.isDeleted != true)
                        .map((item, index) => {
                          return (
                            <tr key={index}>
                              
                                <td>
                                  {checkedValue ? (
                                    <input
                                      type="checkbox"
                                      id="activeValue"
                                      name="activeValue"
                                      checked={
                                        checkedValues.filter(
                                          (ele) => ele.id == item.id
                                        ).length > 0
                                          ? true
                                          : false
                                      }
                                      onChange={(event) =>
                                        onCheckedValue(
                                          event.target.checked,
                                          item
                                        )
                                      }
                                    />
                                  ) : (
                                    <input
                                      type="checkbox"
                                      id="activeValue"
                                      name="activeValue"
                                      checked={checkedValues.includes(item)}
                                      onChange={(event) =>
                                        onCheckedValue(
                                          event.target.checked,
                                          item
                                        )
                                      }
                                    />
                                  )}
                                </td>
                              
                              <td className="w-10 word-break text-center">
                                {index + 1}
                              </td>
                              <td className="word-break">
                                {item.selectedExam
                                  ? getExamName(item.selectedExam)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {days[new Date(item.examDate).getDay()]} ,{" "}
                                {item.examDate
                                  ? dayjs(item.examDate).format("DD/MM/YYYY")
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.presentTime
                                  ? formatAMPM(item.presentTime)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.lastEnterTime
                                  ? formatAMPM(item.lastEnterTime)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.examStartTime
                                  ? formatAMPM(item.examStartTime)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.examEndTime
                                  ? formatAMPM(item.examEndTime)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.examSubject
                                  ? examSubjectName(item.examSubject)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.language
                                  ? languageName(item.language)
                                  : ""}
                              </td>
                              <td className="word-break">
                                {item.subjectCode ? item.subjectCode : ""}
                              </td>
                              <td className="word-break">
                                {item.examType
                                  ? examTypeName(item.examType)
                                  : ""}
                              </td>
                            </tr>
                          );
                        })}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
          <div>
            <div className="col-md-12 horizontalLineCss">
              <div className="row">
                <div className="col-md-4">
                  <label className="LeftText">
                    {TimeTableLabels.SELECT_EXAM_TEMPLATE}
                    <span className="errorText">*</span>
                  </label>
                  <div className="input-group bg-color">
                    <select
                      className="form-select  bg-color"
                      name="examTemplate"
                      value={examTemplate}
                      defaultValue={examTemplate}
                      onInput={(e) => {
                        handleExamTemplateChange(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {getAdmitCardTemplateList && getAdmitCardTemplateList.lookupOptionDtoList && getAdmitCardTemplateList.lookupOptionDtoList.length > 0 && 
                        getAdmitCardTemplateList.lookupOptionDtoList
                          .sort((a, b) => {
                            return Number(a.sortOrder) - Number(b.sortOrder);
                          })
                          .map((ele, ind) => {
                            return (
                              <option key={ind++} value={ele.id}>
                                {ele.label}
                              </option>
                            );
                          })}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <label className="LeftText">
                    {TimeTableLabels.EXAM_DISPLAY_NAME}
                    <span className="errorText">*</span>
                  </label>
                  <Controller
                    name="admitCardDisplayName"
                    control={control}
                    key="admitCardDisplayName"
                    defaultValue={admitCardDisplayName}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          handleAdmitCardDisplayNameChange(e);
                        }}
                        value={admitCardDisplayName}
                      />
                    )}
                  />
                </div>
                <div className="col-md-4">
                  <label className="LeftText">
                    {TimeTableLabels.SIGNATURE}
                  </label>
                  <Controller
                    name="signature"
                    control={control}
                    key="signature"
                    defaultValue={signature}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          if (e.length <= 200) {
                            setSignature(e);
                            setSignatureLengthErr(false);
                          } else {
                            setSignatureLengthErr(true);
                          }
                        }}
                        value={signature}
                      />
                    )}
                  />
                  {signatureLengthErr && (
                    <p className="errorText">
                      {TimeTableLabels.MAX_VALUE_FOR_200_CHAR}
                    </p>
                  )}
                </div>

                <div className="col-md-4">
                  <label className="LeftText">
                    {TimeTableLabels.AUTHORITY}
                  </label>
                  <Controller
                    name="authority"
                    control={control}
                    key="authority"
                    defaultValue={authority}
                    render={({ onChange, value }) => (
                      <Devnagari
                        onChange={(e) => {
                          if (e.length <= 200) {
                            setAuthority(e);
                            setAuthorityLengthErr(false);
                          } else {
                            setAuthorityLengthErr(true);
                          }
                        }}
                        value={authority}
                      />
                    )}
                  />
                  {authorityLengthErr && (
                    <p className="errorText">
                      {TimeTableLabels.MAX_VALUE_FOR_200_CHAR}
                    </p>
                  )}
                </div>
              </div>
              <label className="mb-2 font-weight-bold ml-2 mt-2">
                {TimeTableLabels.IMPORTANT_INSTRUCTION}
              </label>
              <CKEditor
                editor={ClassicEditor}
                data={impInstruction}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setImpInstruction(data);
                }}
              />
              {/* <CDNCKEditor
                  data={impInstruction}
                  onChange={(newData) => setImpInstruction(newData)}
                /> */}
            </div>

            <div className="col-md-12 ">
              <label className="mt-2 mb-2 font-weight-bold ml-2">
                {TimeTableLabels.INSTRUCTIONS_FOR_CANDIDATE}
              </label>
              <CKEditor
                editor={ClassicEditor}
                data={candidateInstruction}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setCandidateInstruction(data);
                }}
              />
              {/* <CDNCKEditor
                data={candidateInstruction}
                onChange={(newData) => setCandidateInstruction(newData)}
              /> */}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={cancelModal}
          >
            {commonLabels.BUTTON_CANCEL}
          </button>
          {subjectCode == "042" || subjectCode == "043" ? (
            <button
              className=" btn btn-primary custom_button "
              type="submit"
              disabled={
                ((tempTimeTableData && tempTimeTableData.length === 0) ||
                  !examTemplate ||
                  !admitCardDisplayName ||
                  !authority ||
                  !signature ||
                  !candidateInstruction ||
                  !impInstruction) &&
                (!selectedExam ||
                  !selectedExamDate ||
                  !presentTime ||
                  !lastEnterTime ||
                  !examStartTime ||
                  !examEndTime ||
                  !examSubject ||
                  !subjectCode ||
                  !examType ||
                  !candidateInstruction ||
                  !impInstruction ||
                  !language ||
                  authorityLengthErr ||
                  signatureLengthErr ||
                  examTemplateErr ||
                  admitCardDisplayNameErr)
              }
              onClick={handleSubmit}
            >
              {venueLabels.SAVE}
            </button>
          ) : (
            <button
              className=" btn btn-primary custom_button "
              type="submit"
              disabled={
                ((checkedValues && checkedValues.length === 0) ||
                  !examTemplate ||
                  !admitCardDisplayName ||
                  !authority ||
                  !signature ||
                  !candidateInstruction ||
                  !impInstruction) &&
                (!selectedExam ||
                  !selectedExamDate ||
                  !presentTime ||
                  !lastEnterTime ||
                  !examStartTime ||
                  !examEndTime ||
                  !examSubject ||
                  !subjectCode ||
                  !examType ||
                  !candidateInstruction ||
                  !impInstruction ||
                  authorityLengthErr ||
                  signatureLengthErr ||
                  examTemplateErr ||
                  admitCardDisplayNameErr)
              }
              onClick={handleSubmit}
            >
              {venueLabels.SAVE}
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default UpdateTimeTableDetails;
